








import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomChip extends ComponentVue {
  @Prop({ type: String })
  color!: string
}
